<template>
  <v-layout row fill-height class="home">
    <v-layout column>
      <v-flex>
        <v-tabs>
          <template v-if="stToken">
            <v-tab :to="'/codes'"
                   v-if="isSectionAllowed('codes')">
              Code List
            </v-tab>
            <v-tab :to="'/pending-transactions'"
                   v-if="isSectionAllowed('pending-transactions')">
              Pending Transactions
            </v-tab>
            <v-tab :to="'/completed-transactions'"
                   v-if="isSectionAllowed('completed-transactions')">
              Completed Transactions
            </v-tab>
          </template>
          <!-- <v-tab :to="'/settings'" v-if="isSectionAllowed('settings')">Settings</v-tab> -->
        </v-tabs>
        <keep-alive>
          <router-view name="tab"></router-view>
        </keep-alive>
      </v-flex>
    </v-layout>
    <router-view name="sidebar"></router-view>
    <spinner-dialog :type="spinnerType" :shown="spinnerDialog"></spinner-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

import { getNecessaryRedirectPath } from '@/services/AuthService'
import EventBus from '@/utils/event-bus';

import SpinnerDialog from '@/components/SpinnerDialog'

export default {
  components: {
    'spinner-dialog': SpinnerDialog,
  },
  data () {
    return {
      spinnerDialog: false,
      spinnerType: ''
    }
  },
  async created () {
    await this.$store.dispatch('settings/load')
    await this.$store.dispatch('codes/loadCodeList')
    await this.$store.dispatch('transactions/loadTransactionList')
    await this.$store.dispatch('scmFields/loadSCMFieldList')
  },
  mounted () {
    EventBus.$on('spinner-msg', this.handleSpinner)
  },
  beforeDestroy () {
    EventBus.$off('spinner-msg')
  },
  methods: {
    isSectionAllowed (section) { return !getNecessaryRedirectPath(section) },
    handleSpinner (msg) {
      if (msg.off) return this.spinnerDialog = false
      this.spinnerType = msg.type
      this.spinnerDialog = true
      if (msg.type != 'loading') setTimeout(() => this.spinnerDialog = false, 1500)
    }
  },
  computed: {
    ...mapGetters('settings', [
      'stToken'
    ])
  }
}
</script>

<style lang="scss">
.total-ctn {
  padding-left: 16px;
  padding-top: 10px;
  font-size: 13px;
  font-weight: 500;
  color: #858585;
}

.loading{
  position: absolute;
  margin-top: 0px;
  top: 0px;
}
</style>
